export class PropostaObservacao {
  public id!: number;
  public dtInclusao!: Date;
  public proposta!: number;
  public observacao!: string;
  public obsBanco!: number;
  public idUsuario!: number;
  public usuario!: string;
}
